"use client";

import { useEffect, useRef } from "react";
import { trackEvent } from "@/lib/analytics/posthog";
import { logger } from "@/lib/logger";

export function VisitorsTracker() {
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (!hasTrackedRef.current) {
      logger.info("[PostHog] Tracking visitors_landing_page");
      trackEvent("visitors_landing_page");
      hasTrackedRef.current = true;
    }
  }, []);

  return null;
}
